import React from 'react';
import { Nav } from './Nav';
import { NavLink, Outlet } from 'react-router-dom';

export const MyPage = () => {
  return (
    <>
      <div className='mypage-right'>
        <Nav />
        <div className='tabs tabs-dashboard'>
          <NavLink
            to={'/user/mypage/mycards'}
            className={({ isActive }) =>
              isActive ? 'tab tab-selected' : 'tab'
            }
          >
            My Cards
          </NavLink>
          <NavLink
            to={'/user/mypage/notifications'}
            className={({ isActive }) =>
              isActive ? 'tab tab-selected' : 'tab'
            }
          >
            Notifications
          </NavLink>
        </div>
        <h1>Your Dashboard</h1>
        <Outlet />
      </div>
    </>
  );
};
